<template>
  <div>
    <!--Contents-->
    New OAuth2.0 User enroll form
    <!--//Contents -->
  </div>
</template>
<script>
/* eslint-disable */
export default {
    name: 'OAuthNewUser.vue',
    mounted() {
        //this.$store.commit('register', '');
    }
};
</script>

<style>
</style>